module.exports = __webpack_public_path__ + "static/20-7613fa6ec2c866208827f9eef9227ee1.gif";